import styled from 'styled-components';

export const JackpotWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 510px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const JackpotBg = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
`;

export const DigitsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  display: flex;
  justify-content: center;
  align-items: center;
  
  padding: 0 4.5%; 
  box-sizing: border-box;
`;

export const SlotWindow = styled.div`
  position: relative;
  width: 12.5%; 
  
  height: 52%; 
  
  margin-top: 0.5%;
  margin: 0 0.2%;
  
  overflow: hidden;
`;

export const ReelStrip = styled.div<{ $targetIndex: number; $duration: number; $delay: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  
  height: 1000%; 
  
  display: flex;
  flex-direction: column;
  
  transform: translateY(-${props => props.$targetIndex * 10}%);
  
  transition: transform ${props => props.$duration}s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition-delay: ${props => props.$delay}s;
  
  will-change: transform;
`;

export const ReelImage = styled.img`
  width: 100%;
  
  height: 10%; 
  
  object-fit: contain;
  display: block;
`;